module.exports = __webpack_public_path__ + "img/hy_mrqhl.206c8bc8.svg";